module.exports = ".form-control-plaintext {\n  width: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/schemas/schema-copy.modal.scss
// module id = 577
// module chunks = 1